export default __webpack_public_path__ + "static/media/Quicksand-Regular.109d09e5.ttf";